import OpenApiJSON from './swagger.json'

export default OpenApiJSON
export const schemas = OpenApiJSON.components.schemas
